import { useEffect, useState, useRef } from "react";
import { io } from "socket.io-client";
import axios from "axios";
import { useSelector } from "react-redux";
import {
  FaComments,
  FaImage,
  FaPaperPlane,
  FaSearch,
  FaSmile,
  FaTimes,
} from "react-icons/fa";
import OrderDetail from "./OrderDetail";
import { server, serverUrl } from "../../Config/Config";
// import { server, serverUrl } from "../../config/apiConfig";

const socket = io(`${serverUrl}/chat-request`);

const BulkChat = () => {
  const [selectedChat, setSelectedChat] = useState(null);
  const [chats, setChats] = useState([]); // Unique chat users
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const chatsRef = useRef([]); // Track users who have messaged
  const messagesEndRef = useRef(null);
  const fileInputRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [files, setFiles] = useState([]);
  const [preview, setPreview] = useState([]);

  const { currentUser } = useSelector((state) => state.store);
  const vendorId = currentUser?._id;

  useEffect(() => {
    const fetchChatUsers = async () => {
      try {
        const res = await axios.get(`${server}chat-users/${vendorId}`);
        setChats(res.data); // Store initial chat users
        chatsRef.current = res.data.map((chat) => chat._id.sender_id); // Track existing users
      } catch (error) {
        console.error("Error fetching chat users:", error);
      }
    };

    fetchChatUsers();
  }, [vendorId]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);
  useEffect(() => {
    if (!vendorId) return;

    socket.emit("register", vendorId);

    socket.on("receiveMessage", (newMessage) => {
      const senderId = newMessage._id.sender_id;
      const productId = newMessage._id.product_id;
      console.log("new messssg", newMessage);
      console.log("chatref", chatsRef);

      setChats((prevChats) => {
        const chatMap = new Map(
          prevChats.map((chat) => [
            `${chat._id.sender_id}-${chat._id.product_id}`,
            chat,
          ])
        );
        chatMap.set(`${senderId}-${productId}`, newMessage);
        return Array.from(chatMap.values());
      });
      if (
        selectedChat &&
        senderId === selectedChat._id.sender_id &&
        productId === selectedChat._id.product_id
      ) {
        setMessages((prev) => [...prev, newMessage]);
      }
    });

    return () => {
      socket.off("receiveMessage");
    };
  }, [selectedChat, vendorId]);

  const fetchMessages = async (chat) => {
    setSelectedChat(chat);
    try {
      const res = await axios.get(
        `${server}messages/${vendorId}/${chat._id.sender_id}/${chat._id.product_id}`
      );
      setMessages(res.data);
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  const sendMessage = async () => {
    // if (!message.trim() || !selectedChat) return;

    if (!message.trim() && files.length === 0) return;
    let imageUrl = null;
    console.log("files", files);
    if (files.length > 0) {
      const formData = new FormData();
      files.forEach((file) => formData.append("files", file));
      formData.append("receiverId", selectedChat._id.sender_id);
      formData.append("senderId", vendorId);
      try {
        const response = await axios.post(
          "http://localhost:5002/api/v1/upload",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        console.log("response ", response);
        imageUrl = response.data.filePaths;

        imageUrl.forEach((fileData) => {
          const data = {
            sender_id: vendorId,
            receiver_id: selectedChat._id.sender_id,
            product_id: selectedChat._id.product_id,
            file: fileData,
          };

          socket.emit("sendMessage", data);
          console.log("data", data);
          setMessages((prev) => [...prev, data]);
          setMessage("");
          setPreview([]);
        });
      } catch (error) {
        console.error("Error uploading image:", error);
        return;
      }
    }
    console.log("imag url", imageUrl);
    if (message.trim()) {
      const newMessage = {
        sender_id: vendorId,
        receiver_id: selectedChat._id.sender_id,
        product_id: selectedChat._id.product_id,
        message,
      };

      socket.emit("sendMessage", newMessage);
      setMessages((prev) => [...prev, newMessage]);
      setMessage("");
    }
  };
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles((prev) => [...prev, ...selectedFiles]);

    const readFiles = selectedFiles.map((file) => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(file);
      });
    });
    Promise.all(readFiles).then((newPreviews) => {
      setPreview((prev) => [...prev, ...newPreviews]);
    });
  };
  const filteredChats = chats.filter((chat) =>
    chat?.sender?.first_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const lastMessage = messages?.length;
  console.log("message", messages[lastMessage - 1]);
  console.log("selected chat", selectedChat);
  console.log("letest message", lastMessage);
  return (
    <div className="flex justify-evenly p-5 gap-5 ">
      {/* Sidebar: List of customers */}
      <div className="w-1/4 p-4 border rounded-md bg-white shadow-lg">
        {/* Sidebar Heading */}
        <h2 className="font-bold text-xl text-[--color--1] border-b pb-3 mb-4 flex items-center gap-2">
          <FaComments size={22} className="text-[--color--1]" />
          Customer Inquiries
        </h2>
        {/* Search Bar */}
        <div className="relative mb-4">
          <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search users..."
            className="w-full pl-10 pr-3 py-2 border rounded-lg focus:ring-2 focus:ring-green-400 text-sm"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        {/* Chat List */}
        <div className="space-y-3 max-h-[70vh] overflow-y-auto scrollbar-thin scrollbar-thumb-green-300 scrollbar-track-green-100 pr-1">
          {filteredChats.length === 0 ? (
            <p className="text-green-600 text-center mt-4">No messages found</p>
          ) : (
            filteredChats.map((chat) => (
              <div
                key={`${chat._id.sender_id}-${chat._id.product_id}`}
                className={`flex items-center justify-between p-3 rounded-lg cursor-pointer transition-all border ${
                  selectedChat?._id?.sender_id === chat._id.sender_id &&
                  selectedChat?._id?.product_id === chat._id.product_id
                    ? "bg-green-50 border-[--color--1] shadow-md"
                    : "hover:bg-green-200 hover:border-green-300"
                }`}
                onClick={() => fetchMessages(chat)}
              >
                <div className="flex items-center gap-3">
                  <div>
                    <p className="text-gray-800 font-semibold">
                      {chat?.sender?.first_name}
                    </p>
                    <p className="text-gray-500 text-sm truncate ">
                      {chat?.product?.name || "No messages yet..."}
                    </p>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {/* Chat Window */}
      {/* Chat Window */}
      <div className="p-4 w-1/2 border border-gray300 rounded-2xl shadow-xl bg-white">
        {/* Header */}

        {selectedChat ? (
          <>
            <h2 className="text-lg font-semibold text-[--color--1]">
              Chat with {selectedChat?.sender?.first_name}
            </h2>
            <p className="text-gray-500 text-sm truncate ">
              {selectedChat?.product?.name || "No messages yet..."}
            </p>
            <div className="border border-gray200 p-3 h-[50vh] overflow-auto mt-2 rounded-xl bg-gray100 shadow-inner">
              {messages.map((msg, index) => (
                <div
                  key={index}
                  className={`flex my-2 ${
                    msg.sender_id === vendorId ? "justify-end" : "justify-start"
                  }`}
                >
                  <div
                    className={`p-3 max-w-xs rounded-xl shadow-md text-sm ${
                      msg.sender_id === vendorId
                        ? "bg-[--color--1] text-white"
                        : "bg-gray200 text-gray800"
                    }`}
                  >
                    {msg.file && (
                      <img
                        src={msg.file}
                        alt="Sent"
                        className="w-32 h-32 rounded-lg mb-2"
                      />
                    )}
                    <p>{msg.message}</p>
                    <span
                      className={`block text-xs mt-1 text-right ${
                        msg.sender_id === vendorId
                          ? "bg-[--color--1] text-white"
                          : "bg-gray200 text-gray500"
                      }`}
                    >
                      {msg.created_at
                        ? new Date(msg.created_at).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                            // hour12: false,
                          })
                        : new Date().toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                            // hour12: false,
                          })}
                    </span>
                  </div>
                </div>
              ))}
              <div ref={messagesEndRef} />
            </div>

            {/* Image Preview (Now Above Input) */}
            {preview.length > 0 && (
              <div className="mt-3 flex gap-2">
                {preview.map((src, index) => (
                  <div key={index} className="relative">
                    <img
                      src={src}
                      alt="Preview"
                      className="w-20 h-20 rounded-md"
                    />
                    <button
                      onClick={() => {
                        setFiles((prev) => prev.filter((_, i) => i !== index));
                        setPreview((prev) =>
                          prev.filter((_, i) => i !== index)
                        );
                      }}
                      className="absolute top-1 right-1 text-red-500 hover:text-red-700"
                    >
                      <FaTimes size={18} />
                    </button>
                  </div>
                ))}
              </div>
            )}

            {/* Input Section */}
            <div className="flex items-center gap-2 mt-3 bg-gray100 p-2 rounded-lg">
              <button
                onClick={() => fileInputRef.current.click()}
                className="text-[--color--1] hover:text-green800 p-2"
              >
                <FaImage size={20} />
              </button>
              <input
                type="text"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Type a message..."
                className="flex-1 bg-white border border-gray300 p-2 rounded-lg focus:ring-2 focus:ring-green400 text-sm"
              />
              {/* <button className="text-green600 hover:text-green800 p-2">
                <FaSmile size={20} />
              </button> */}
              <button
                onClick={sendMessage}
                className="bg-[--color--1] text-white p-2 rounded-lg hover:bg-green600"
              >
                <FaPaperPlane size={20} />
              </button>
              <input
                type="file"
                ref={fileInputRef}
                accept="image/*"
                className="hidden"
                onChange={handleFileChange}
              />
            </div>
          </>
        ) : (
          <div className="h-full flex flex-col items-center justify-center text-gray-500 text-lg font-medium bg-gray-50 rounded-lg shadow-inner p-6">
            <FaComments size={50} className="mb-4 text-[--color--1]" />
            <p className="text-center">No chat selected</p>
            <p className="text-gray-400 text-sm text-center mt-1">
              Select a conversation to start messaging.
            </p>
          </div>
        )}
        {/* Messages */}
      </div>
      {selectedChat ? (
        <div className="w-[30%]">
          <OrderDetail data={selectedChat?.product} />
        </div>
      ) : (
        <div className="w-[30%] flex flex-col items-center justify-center bg-gray-100 p-6 rounded-lg shadow-md">
          <img
            src="https://cdn-icons-png.flaticon.com/512/4076/4076549.png"
            alt="No Product Selected"
            className="w-24 h-24 opacity-60"
          />
          <p className="text-gray-500 text-lg font-semibold mt-4">
            No product selected
          </p>
          <p className="text-gray-400 text-sm text-center mt-1">
            Please select a product to view details.
          </p>
        </div>
      )}
      {/* {viewImage && <ImageViewer imageUrl={imageUrl} setViewImage={setViewImage}/>} */}
    </div>
  );
};

export default BulkChat;
